import { TFunction } from "i18next";
import { format } from "date-fns";
import CONSTANTS from "core/constants";
import { IcbtPaymentData } from "./types";
import { Filter } from "../shared/types";

export const formatIcbtPaymentTableData = (data: IcbtPaymentData[]) =>
  data.map(
    ({ answerId, createdAt, firstName, lastName, nationalIdentity }) => ({
      id: answerId,
      answerId,
      createdAt: format(
        new Date(createdAt),
        CONSTANTS.DATE_FORMAT.YEAR_NAME_DATE_SECONDS_FORMAT,
      ),
      nationalIdentity,
      patientFirstName: firstName,
      patientLastName: lastName,
    }),
  );

export const getIcbtPaymentTableColumns = (t: TFunction) => {
  // id is used for sorting tables, this value should be
  // same as the object key for the specific column.
  return [
    {
      id: "answerId",
      numeric: false,
      disablePadding: false,
      label: t("ID"),
    },
    {
      id: "createdAt",
      numeric: false,
      disablePadding: false,
      label: t("TIME"),
    },
    {
      id: "nationalIdentity",
      numeric: false,
      disablePadding: false,
      label: t("NATIONAL_IDENTITY"),
    },
    {
      id: "patientFirstName",
      numeric: false,
      disablePadding: false,
      label: `${t("FIRSTNAME")}`,
    },
    {
      id: "patientLastName",
      numeric: false,
      disablePadding: false,
      label: `${t("LASTNAME")}`,
    },
  ];
};

interface Filters {
  fromDate: number;
  toDate: number;
}

export const getIcbtPaymentTableFilters = (t: TFunction, values: Filters) => {
  const filters: Filter[] = [
    {
      id: "fromDate",
      type: "date",
      label: t("FROM_TIME"),
    },
    {
      id: "toDate",
      type: "date",
      label: t("TO_TIME"),
    },
  ];

  return filters.map((value: Filter) => {
    const curValue = values[value.id as keyof Filters];
    const updatedFilter = value;
    if (curValue) {
      updatedFilter.value = curValue;
    }

    return updatedFilter;
  });
};

export const getIcbtPaymentTableSensitiveFields = () => [
  "nationalIdentity",
  "patientFirstName",
  "patientLastName",
];
